<button [disabled]="disabled"  [nbTooltip]="tooltip" [nbTooltipDisabled]="tooltip == ''" [ngClass]="{'button-header-ghost': !withPadding}" nbButton ghost onclick="this.blur();" (click)="onButtonClicked($event)">
  <app-icon class="{{currentAnimationComponent}}" [status]="statusCalculated" [icon]="icon"></app-icon>
</button>
